"use client"

import React from "react";
import { useRouter } from "next/router";
import clsx from "clsx";

type Props = {
  amount: number;
  currency: "INR" | "USD";
  className?: string;
};
export default function CurrentCurrency({
  amount,
  currency: currencyParam,
  className,
}: Props) {
  const router = null; /* useRouter(); */
  let { locale, currency } = router?.query || { currency: currencyParam };

  locale = locale || "en-US";
  currency = currency || "USD";

  if (!amount.toLocaleString) {
    return <span className="font-mono text-sm">${amount}</span>;
  }

  return (
    <span className={clsx("font-mono text-sm", className)}>
      {amount.toLocaleString(locale, {
        style: "currency",
        currencyDisplay: "symbol",
        currency,
        minimumFractionDigits: 0,
      })}
    </span>
  );
}
